// import PrivateRoute from "./privateRoute";
// import { Routes, Route } from "react-router-dom";
// import Home from "./pages/Home";
// import McCORD_Login from "./pages/McCORD_Login";
// import Main from "./components/layout/Main";
// import Login from "./components/layout/Login";
// import ResetPassword from "./components/layout/ResetPassword";
// import "antd/dist/antd.css";
// import "./assets/styles/main.css";
// // import "./assets/styles/Schematics.css";
// import "./assets/styles/SchematicsNew.css";
// import "./assets/styles/responsive.css";
// import MccordDashboard from "./pages/MccordDashboard";
// import Water from "./pages/Water";
// import Accountnames from "./pages/Accountnames";
// import Healthstatus from "./pages/Healthstatus";
// import TotalFlow from "./pages/TotalFlow";
// import TotalFlows from "./pages/TotalFlowarea";
// import Devices from "./pages/Devices";
// import Schematics from "./pages/Schematics";
// // import SchematicsNew from "./pages/SchematicsNew";
// import Schematicss from "./pages/Schematicss";
// import Stats from "./pages/stats";
// import Outliers from "./pages/Outliers";
// import Outlierovertime from "./pages/Outlierovertime";
// import Apps from "./pages/Setting";
// import Listuser from "./pages/Listuser";
// import Waters from "./pages/Waters";
// import AccountStats from "./pages/AccountStats";
// import AccountTable from "./pages/AccountTable";
// import Outliersnew from "./pages/Outliersnew";
// import Registration from "./pages/Registration";
// import Listregistereduser from "./pages/ListregisteredUser";
// import FlowHealth from "./pages/FlowHealth";
// import Notificationss from "./pages/Notification";
// import Alerts from "./pages/Alert";
// import Profile from "./pages/Profile";
// import Prediction_flow from "./pages/prediction";
// import WaterAgg from "./pages/wateraggregate";
// import Anomaly from "./pages/Anomaly";
// import VideoPlayer from "./pages/VideoPlayer";
// import Parkingdata from "./pages/ParkingData";
// import MeterManagement from "./pages/MeterManagement";
// import WaterMeterReading from "./pages/WaterMeter";
// import SchematicsDemo from "./pages/schematicsDemo";
// import { Navigate } from "react-router-dom";

// function App() {
//   return (
//     <div className="App">
//       <Routes>
     
//         <Route exact path="/login" component={Login} />
//         <PrivateRoute exact path="/resetpassword" component={McCORD_Login} />
//         <PrivateRoute exact path="/dashboard" component={Home} />
//         <PrivateRoute exact path="/settings" component={Water} />
//         <PrivateRoute exact path="/waters" component={Waters} />
//         <PrivateRoute exact path="/wateragg" component={WaterAgg} />
//         <PrivateRoute exact path="/watermeterreadings" component={WaterMeterReading} />
//         <PrivateRoute exact path="/Anomaly" component={Anomaly} />
//         <PrivateRoute exact path="/vehicle-parking" component={VideoPlayer} />
//         <PrivateRoute exact path="/Parking" component={Parkingdata} />
//         <PrivateRoute exact path="/schematicsMap" component={SchematicsDemo} />

//         <PrivateRoute exact path="/settingsuser" component={Listuser} />
//         <PrivateRoute exact path="/list" component={Listregistereduser} />
//         <PrivateRoute exact path="/notification" component={MccordDashboard} />
//         <PrivateRoute exact path="/accountnames" component={Accountnames} />
//         <PrivateRoute exact path="/health" component={Healthstatus} />
//         <PrivateRoute exact path="/totalflow" component={TotalFlow} />
//         <PrivateRoute exact path="/flowhealth" component={FlowHealth} />
//         <PrivateRoute exact path="/devices" component={Devices} />
//         {/* <PrivateRoute exact path="/schematics-latest" component={SchematicsNew} /> */}
//         <PrivateRoute exact path="/schematics" component={Schematics} />
//         <PrivateRoute exact path="/schematics-new" component={Schematicss} />
//         <PrivateRoute exact path="/stats" component={Stats} />
//         <PrivateRoute exact path="/outliers" component={ Outliers} />
//         <PrivateRoute exact path="/totalflow" component={ TotalFlow} />
//         <PrivateRoute exact path="/totalflowarea" component={ TotalFlows} />
//         <PrivateRoute exact path="/outliersnew" component={ Outliersnew} />
//         <PrivateRoute exact path="/accountstats" component={ AccountStats} />
//         <PrivateRoute exact path="/notificationss" component={ Notificationss} />
//         <PrivateRoute exact path="/account-table" component={ AccountTable} />
//         <PrivateRoute exact path="/reset" component={ ResetPassword} /> 
//         <PrivateRoute exact path="/registration" component={ Registration} />
//         <PrivateRoute exact path="/profile" component={ Profile} />
//         <PrivateRoute exact path="/outlierovertime" component={Outlierovertime} />
//         <PrivateRoute exact path="/alert" component={Alerts} />
//         <PrivateRoute exact path="/predictiveanalysis" component={Prediction_flow} />
//         <PrivateRoute exact path="/metermanagement" component={MeterManagement} />
//         {/* <Redirect from="*" to="/login" /> */}
//         <Navigate to="/login" replace />

//       </Routes>
//     </div>
//   );
// }

// export default App;
import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import ReactGA from 'react-ga4';
import usePageTracking from './usePageTracking';
import useTimeTracking from './PageLayout';

// Page Imports
import Login from "./components/layout/Login";
import McCORD_Login from "./pages/McCORD_Login";
import Home from "./pages/Home";
import Water from "./pages/Water";
import Waters from "./pages/Waters";
import WaterAgg from "./pages/wateraggregate";
import WaterMeterReading from "./pages/WaterMeter";
// import Anomaly from "./pages/Anomaly";
// import Anomalynew from "./pages/Anomalynew";
import AnomalyMain from "./pages/AnomalyMain";
import VideoPlayer from "./pages/VideoPlayer";
import Parkingdata from "./pages/ParkingData";
import SchematicsDemo from "./pages/schematicsDemo";
import Listuser from "./pages/Listuser";
import Listregistereduser from "./pages/ListregisteredUser";
import MccordDashboard from "./pages/MccordDashboard";
import Accountnames from "./pages/Accountnames";
import Healthstatus from "./pages/Healthstatus";
import TotalFlow from "./pages/TotalFlow";
import TotalFlows from "./pages/TotalFlowarea";
import FlowHealth from "./pages/FlowHealth";
import Devices from "./pages/Devices";
import Schematics from "./pages/Schematics";
import Schematicss from "./pages/Schematicss";
import Stats from "./pages/stats";
import Outliers from "./pages/Outliers";
import Outliersnew from "./pages/Outliersnew";
import Outlierovertime from "./pages/Outlierovertime";
import AccountStats from "./pages/AccountStats";
import AccountTable from "./pages/AccountTable";
import ResetPassword from "./components/layout/ResetPassword";
import Registration from "./pages/Registration";
import Profile from "./pages/Profile";
import Alerts from "./pages/Alert";
import Prediction_flow from "./pages/prediction";
import MeterManagement from "./pages/MeterManagement";
import Schematicsdynamic from "./pages/schematicsdynamic";
import Notificationss from "./pages/Notification";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/SchematicsNew.css";
import "./assets/styles/responsive.css";
import { DistrictProvider } from "./utils/DistrictContext";
import MeterHistory from "./pages/MeterHistory";

// Initialize with your Measurement ID
// ReactGA.initialize('G-7X9MRX6GZD');

function App() {
    ReactGA.set({ debug_mode: true }); 
    usePageTracking(); // Track page views automatically
    useTimeTracking(); // This will send duration on page when user exits
    useEffect(() => {
    const title =
      window.location.href.indexOf("mizuwatch.com") > -1
        ? "MizuWatch"
        : "MizuSmart";
    document.title = title;
  }, []);
  return (
    <div className="App">
       <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <DistrictProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/resetpassword" element={<PrivateRoute><McCORD_Login /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/settings" element={<PrivateRoute><Water /></PrivateRoute>} />
        <Route path="/waters" element={<PrivateRoute><Waters /></PrivateRoute>} />
        <Route path="/wateragg" element={<PrivateRoute><WaterAgg /></PrivateRoute>} />
        <Route path="/watermeterreadings" element={<PrivateRoute><WaterMeterReading /></PrivateRoute>} />
        {/* <Route path="/Anomaly" element={<PrivateRoute><Anomaly /></PrivateRoute>} /> */}
        {/* <Route path="/Anomalynew" element={<PrivateRoute><Anomalynew /></PrivateRoute>} />  */}
        <Route path="/Anomaly" element={<PrivateRoute><AnomalyMain /></PrivateRoute>} />
        <Route path="/vehicle-parking" element={<PrivateRoute><VideoPlayer /></PrivateRoute>} />
        <Route path="/Parking" element={<PrivateRoute><Parkingdata /></PrivateRoute>} />
        <Route path="/schematicsMap" element={<PrivateRoute><SchematicsDemo /></PrivateRoute>} />
        <Route path="/settingsuser" element={<PrivateRoute><Listuser /></PrivateRoute>} />
        <Route path="/meterhistory" element={<PrivateRoute><MeterHistory /></PrivateRoute>} />
        <Route path="/list" element={<PrivateRoute><Listregistereduser /></PrivateRoute>} />
        <Route path="/notification" element={<PrivateRoute><MccordDashboard /></PrivateRoute>} />
        <Route path="/accountnames" element={<PrivateRoute><Accountnames /></PrivateRoute>} />
        <Route path="/health" element={<PrivateRoute><Healthstatus /></PrivateRoute>} />
        <Route path="/totalflow" element={<PrivateRoute><TotalFlow /></PrivateRoute>} />
        <Route path="/flowhealth" element={<PrivateRoute><FlowHealth /></PrivateRoute>} />
        <Route path="/devices" element={<PrivateRoute><Devices /></PrivateRoute>} />
        <Route path="/schematics" element={<PrivateRoute><Schematics /></PrivateRoute>} />
        <Route path="/schematicsdynamic" element={<PrivateRoute><Schematicsdynamic /></PrivateRoute>} />
        <Route path="/schematics-new" element={<PrivateRoute><Schematicss /></PrivateRoute>} />
        <Route path="/stats" element={<PrivateRoute><Stats /></PrivateRoute>} />
        <Route path="/outliers" element={<PrivateRoute><Outliers /></PrivateRoute>} />
        <Route path="/totalflowarea" element={<PrivateRoute><TotalFlows /></PrivateRoute>} />
        <Route path="/outliersnew" element={<PrivateRoute><Outliersnew /></PrivateRoute>} />
        <Route path="/accountstats" element={<PrivateRoute><AccountStats /></PrivateRoute>} />
        <Route path="/account-table" element={<PrivateRoute><AccountTable /></PrivateRoute>} />
        <Route path="/reset" element={<PrivateRoute><ResetPassword /></PrivateRoute>} />
        <Route path="/registration" element={<PrivateRoute><Registration /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/outlierovertime" element={<PrivateRoute><Outlierovertime /></PrivateRoute>} />
        <Route path="/alert" element={<PrivateRoute><Alerts /></PrivateRoute>} />
        <Route path="/predictiveanalysis" element={<PrivateRoute><Prediction_flow /></PrivateRoute>} />
        <Route path="/metermanagement" element={<PrivateRoute><MeterManagement /></PrivateRoute>} />
        <Route path="/notificationss" element={<PrivateRoute><Notificationss /></PrivateRoute> } />
        {/* Redirect all unknown routes to /login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
      </DistrictProvider>
    </div>
  );
}

export default App;
